import { HOST } from "api/apiClient";
import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import H1 from "ReusableComponents/Text/H1";
import { COLORS, SIZES, WEIGHT } from "theme";

const Hero = ({ small, banner }) => {
  return (
    <>
      <Box
        display="flex"
        justifyContent="start"
        alignItems={small ? "start" : "flex-end"}
        h={small ? "530px" : "465px"}
        background={COLORS.white}
        w="100%"
        position="relative"
      >
        <Box
          margin={small ? "40px" : "0 auto 0 170px"}
          textAlign={small ? "center" : "left"}
          position={small && "absolute"}
          left={small && "0"}
          right={small && "0"}
        >
          <H1
            fontSize={small ? SIZES.twentyFour : SIZES.forty}
            fontWeight={WEIGHT.bold}
            textColor={COLORS.black}
            margin="0"
          >
            {banner?.attributes?.title}
          </H1>
          <Box w={small ? "auto" : "421px"}>
            <Text
              fontSize={small ? SIZES.twentyFour : SIZES.forty}
              fontWeight={WEIGHT.bold}
              textColor={COLORS.greyShade}
              marginTop="24px"
            >
              {banner?.attributes?.subtitle}
            </Text>
          </Box>
        </Box>
      </Box>
      <Box
        position={"absolute"}
        right={small ? "0" : "80px"}
        top={small ? "275px" : "125px"}
        left={small && "0"}
      >
        <img
          src={HOST + banner?.attributes?.media?.data?.attributes?.url}
          alt={banner?.attributes?.media?.data?.attributes?.alternativeText}
          height={"100%"}
          width={small && "100%"}
        />
      </Box>
    </>
  );
};

export default Hero;
